import { render, staticRenderFns } from "./apartment-buttons.vue?vue&type=template&id=1be7aac2&"
import script from "./apartment-buttons.ts?vue&type=script&lang=ts&"
export * from "./apartment-buttons.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-buttons.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports